import header from './header.component';

export default angular
  .module('fizyweb.paycell.noauth.header', [])
  .component('fizyPaycellNoAuthHeader', header).name;



// WEBPACK FOOTER //
// src/app/no-auth/components/header/header.module.ts